module.exports = __webpack_public_path__ + "media/images/smart_phone/products/nikuman1-79379c2cb66e12d1c82cbe435d399848.jpeg";